import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { BtnLogin, BtnRegister, Chars, Logo } from "src/assets";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">BIGMX</VisuallyHidden>
      <Stack
        direction="column"
        alignItems="center"
        width="100%"
        textAlign="center"
      >
        <img
          alt="logo"
          src={Logo}
          style={{ width: 324, marginTop: "176px" }}
        />

        <Stack
          direction="row"
          justifyContent="center"
          mt={-1}
          gap={0.5}
          zIndex={11}
        >
          <a
            href={loginUrl}
            onClick={handleClick("login")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-login"
              src={BtnLogin}
              style={{ height: 57 }}
            />
          </a>
          <a
            href={registerUrl}
            onClick={handleClick("register")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-register"
              src={BtnRegister}
              style={{ height: 57 }}
            />
          </a>
        </Stack>

        <img
          alt="chars"
          src={Chars}
          style={{ width: 280, marginTop: "-8px", marginLeft: "30px" }}
        />
      </Stack>
    </Box>
  );
};

const styles = createStyles({
  root: {
    p: "16px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    color: "#fff",
  },
});

export default LandingPage;
